import { all, fork } from 'redux-saga/effects';

import PostSaga from './posts/postSaga';
import { userSaga } from './account/userSaga';
import {botSaga} from './bot/botSaga'
import {apiKeySagas} from './apiKey/apiKeySaga'
import { newsSaga } from './news/newsSaga';
import { tokenSaga } from './token/tokenSaga';
export default function* rootSaga() {
  yield all([
    fork(PostSaga),
    userSaga(),
    botSaga(),
    apiKeySagas(),
    newsSaga(),
    tokenSaga()
  ]);
}
